import React, { useRef, useState } from "react";
import { useParams } from "react-router";
import { useDispatch } from "react-redux";
import Draggable from "react-draggable";
import Form from "../../../../components/common/form/Form";
import Modal from "../../../../components/common/form/Modal";
import ButtonTray from "../../../../components/common/form/ButtonTray";
import { useSendToVendorMutation } from "../../ordersApi";


interface PropertyResult {
    address: string;
    legalDescription: string;
    taxId: string | null;
}

interface Property {
    id: string;
    propertyResult: PropertyResult;
}

interface SendToVendorListProps {
    show: boolean;
    setShow: any;
    productId: string;
    filteredProperties: Property[];
    setFilteredProperties: any;
}

function SendToVendorList({ show, setShow, productId, filteredProperties, setFilteredProperties }: SendToVendorListProps) {
    const { orderId } = useParams<{ orderId: string }>();
    const dispatch = useDispatch();

    const [sendToVendorList, setSendToVendorList] = useState<string[]>([]);
    const [date, setDate] = useState<string>("");
    const [bounds, setBounds] = useState({ left: 0, right: 0 });
    const draggleRef = useRef<HTMLDivElement>(null);
    const [disable, setDisable] = useState(false);
    const [sendToVendorApi, sendToVendorApiRes] = useSendToVendorMutation();



    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (sendToVendorList.length > 0 && orderId) {
            setDisable(true);
            try {
                await sendToVendorApi({
                    propertyIdList: sendToVendorList,
                    productId: productId,
                });
                setShow(false);
            } catch (error) {
                console.error("Error sending to vendor:", error);
            } finally {
                setDisable(false);
            }
        }
    };



    return (
        <Modal
            title={"Send To Vendor"}
            show={show}
            setShow={setShow}
            hoa={true}
            className="w-2/4 bg-text-0 rounded-lg shadow-lg "
            fields={
                <>
                    <Form onSubmit={handleSubmit} fields={<>
                        <div className="modal-body">

                            <table className="w-full bg-text-0">
                                <thead className="bg-text-4 text-text-0 text-left">
                                    <tr>
                                        <th />
                                        <th>Address</th>
                                        <th>Legal</th>
                                        <th>Account No.</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredProperties.length === 0 ? (
                                        <tr>
                                            <td colSpan={4}>There are no properties to send to vendor</td>
                                        </tr>
                                    ) : (
                                        filteredProperties.map((curPropertyId) => (
                                            <tr key={curPropertyId.id}>
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e) => {
                                                            const exists = sendToVendorList.includes(curPropertyId.id);
                                                            const updatedList = exists
                                                                ? sendToVendorList.filter(id => id !== curPropertyId.id)
                                                                : [...sendToVendorList, curPropertyId.id];
                                                            setSendToVendorList(updatedList);
                                                        }}
                                                        value={curPropertyId.id}
                                                        onClick={() => setDate(curPropertyId.id + Date.now())}
                                                        checked={sendToVendorList.includes(curPropertyId.id)}
                                                    />
                                                </td>
                                                <td>{curPropertyId.propertyResult.address}</td>
                                                <td>{curPropertyId.propertyResult.legalDescription}</td>
                                                <td>{curPropertyId.propertyResult.taxId || '-'}</td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>


                        <ButtonTray
                            buttons={[
                                {
                                    buttonProps: {
                                        btnText: "Cancel",
                                        onClick: () => setShow(false),
                                        type: "cancel",
                                    },
                                    buttonType: "button",
                                },
                                {
                                    buttonProps: {
                                        btnText: "Send",
                                        type: "submit",
                                        onClick: handleSubmit,
                                        isDisabled: disable,
                                        isLoading: false,
                                        isHoa: true,
                                    },
                                    buttonType: "button",
                                },
                            ]}
                            align="start"
                            gap={2}
                        />

                    </>}
                    />
                </>
            }
        />
    );
}

export default SendToVendorList;